import axios from "axios"
import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Table } from "reactstrap"

const StatusUpdates = ({ RequestID, setAuth }) => {
  const history = useHistory()

  const [statuses, setStatuses] = useState([])

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      RequestID,
    }
    axios
      .post(
        process.env.REACT_APP_API_URL + "api/ProjectBaladyHistory.php",
        formData
      )
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        // console.log("-------------------------", res.data)
        let array = Object.values(res.data)
        array.splice(-4)

        // console.log("array", array)
        setStatuses(array)
      })
      .catch(err => console.log("error------>", err))
  }, [])

  return (
    <div className="table-responsive">
      <Table className="project-list-table table-nowrap text-center align-middle table-borderless">
        <thead>
          <tr>
            <th scope="col" style={{ width: "20px" }}>
              #
            </th>
            <th scope="col">Status</th>
            <th scope="col">Date</th>
          </tr>
        </thead>

        <tbody>
          {statuses.map((status, i) => (
            <tr key={i}>
              <td>
                {/* <input
                  // value={status.HID}
                  type="checkbox"
                  className="form-check-input  p-1 border-primary"
                /> */}
                {status.HID}
              </td>

              <td>{status.Status}</td>

              <td>{status.CreatedAt}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}

export default StatusUpdates
